import { Injectable, OnDestroy, NgZone, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ModalService } from '../Modal/ModalService';

import { Subscription } from 'rxjs';
import { SystemInformationService } from '../SystemInformation/SystemInformationService';
import { isTruthy } from '../objectUtils';
//import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NSIAuthService implements OnDestroy {
  private refreshTimer?: ReturnType<typeof setTimeout>;
  private readonly ngZone = inject(NgZone);
  mainSubscription: Subscription = new Subscription();

  private toWarningSession = false; 
  private toRun : boolean = true;
  constructor(
    private http: HttpClient,
    private modalS: ModalService,
    private env: SystemInformationService) {
    this.mainSubscription.add(
      this.env.envSettingsBS.subscribe(res => {
        if (res != undefined && res.warningSessionExpires != undefined) {
          this.toWarningSession = isTruthy(res.warningSessionExpires);
        }
      })
    );
  }


  /**
   * Agenda a execução do refresh do token.
   * @param exp Unix timestamp de expiração (em segundos) extraído do JWT.
   * @param bufferSeconds Tempo em segundos para antecipar o refresh - deprecated.
   */
  public scheduleTokenRefresh(exp: number, bufferSeconds: number = 90): void {
    this.clearRefreshTimer();
    
    const nowMs = Date.now();
    const expMs = exp * 1000;

    let delayMs = expMs - nowMs;
    const MAX_TIMEOUT = 2_147_483_647;

    if (delayMs > MAX_TIMEOUT) {
      delayMs = MAX_TIMEOUT;
    }

    //em principio não acontece mas se tivemos um token consistentemente negativo não queremos iniciar o time para não chamar refreshToken eternamente
    if (!(delayMs < 0)) {
      // Executa o setTimeout FORA da zona do Angular para não bloquear o SSR ou a estabilidade da app
      this.ngZone.runOutsideAngular(() => {
        this.refreshTimer = setTimeout(() => {
          console.log('Timer disparou agora');
          if (this.toRun) {
            this.toRun = false;
            // Volta para a zona do Angular ao executar o refresh se for atualizar UI/RxJS
            this.ngZone.run(() => {
              if (this.toWarningSession) {
                console.warn('Token prestes a expirar ou já expirado. Lançando a modal que vai perguntar se quer renovar a sessão.');
                let modal = <models.BaseModalVM>{
                  isError: true,
                  message: "Generic.SessionAboutToExpire", param: {},
                  cancelButton: {
                    hideButton: false,
                    buttonText: "Ok",
                    buttonClass: 'btn-primary',
                    iconClass: "icon-check"
                  }
                };
                this.mainSubscription.add(
                  this.modalS.showModals([modal]).subscribe(res => {
                    this.refreshToken();
                  })
                );
              } else {
                this.refreshToken();
              }
            });
          }

        }, delayMs);
      });
      console.log(`Refresh agendado para daqui a ${Math.round(delayMs / 1000)} segundos.`);
    }
    else {
      //if (this.toWarningSession) {
      //  let modal = <models.BaseModalVM>{
      //    isError: true,
      //    hideHeaderCloseButton: true,
      //    message: "Generic.SessionImpossibleToRefresh", param: {},
      //    cancelButton: {
      //      hideButton: false,
      //      buttonText: "Tentar Novamente?",
      //      buttonClass: 'btn-primary',
      //      iconClass: "icon-check"
      //    }
      //  };
      //  this.mainSubscription.add(
      //    this.modalS.showModals([modal]).subscribe(res => {
      //      this.refreshToken();
      //      //console.log("Tokens expirados.");
      //    })
      //  );
      //}
      console.warn('Não foi possivel renovar a sessão.');
    }

  }

  public clearRefreshTimer(): void {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = undefined;
    }
  }

  public async refreshToken(): Promise<void> {
      console.log('A executar refresh do token...');
      this.http.post<number>('api/NSIAuthService/RefreshToken', {}).subscribe(res => {
        this.toRun = true;

        this.scheduleTokenRefresh(res, 0);
        console.log('Data expiração: ', new Date(res * 1000));

      }, err => {
        console.error(err);
        this.toRun = true;
      });
  }
  ngOnDestroy(): void {
    this.clearRefreshTimer();
    this.mainSubscription.unsubscribe();
  }

  public getWorkflowNavigationUrl(workflowCode: string, instanceId: string, tipoUtilizador: string, isUserService: boolean): string {
    var idPedido = instanceId;
    if (idPedido === "0") {
      idPedido = null;
    }
    else {
      
    }

    var sServicoInfo = "StepServiceInfo";
    var sSubscritorAtendimento = "StepSubscriberInfo";
    var sSender = "StepSender";

    var finalURl = "";
    var criaPedido = "/workflow-create/";
    var criaPedidoPM = "/workflow-create-pm/PEDI002/0/DeceasedIdentification";
    var editaPedido = "workflow/{idpedido}/step/";
    var editaPedidoPM = "workflow/{idpedido}/PEDI002/step/";
    var InstanceBrowser = "/instancebrowser";


    if (!idPedido) {
      finalURl += workflowCode == 'PEDI002' ? criaPedidoPM : workflowCode == 'LST_PEDIDOS' ? InstanceBrowser : criaPedido + workflowCode;
    }
    else {
      finalURl = InstanceBrowser + "/" + idPedido;
      //finalURl += workflowCode == 'PEDI002' ? isUserService ? "" : (editaPedidoPM.replace("{idpedido}", idPedido) + sSender) : (editaPedido.replace("{idpedido}", idPedido) + (tipoUtilizador == "S" ? sServicoInfo : sSubscritorAtendimento));
    }

    return finalURl;
  }
}
